<section
  class="p-3 p-md-4 p-xl-5 d-flex justify-content-center align-items-center section-login"
  style="position: relative"
>
  <div
    class="container d-flex align-items-center justify-content-center"
    style="position: relative; z-index: 2"
  >
    <div class="row d-flex align-items-center justify-content-center">
      <div class="col-12 col-xxl-10">
        <div class="card border-light-subtle shadow-sm">
          <div class="row p-0">
            <div class="col-12 col-md-12">
              <div class="row h-100 card-login d-flex align-items-center justify-content-center">
                <div class="col-12 col-lg-11 col-xl-12">
                  <div class="card-body p-3 px-5">
                    <div class="row">
                      <div class="col-12">
                        <div class="mb-5">
                          <div class="text-center mb-4">
                            <img
                              src="assets/images/logo-new-05-2025.png"
                              alt="BootstrapBrain Logo"
                              width="162"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <form [formGroup]="loginForm">
                        <div class="row gy-3 overflow-hidden input-login-ac">
                          <div class="col-12">
                            <div class="form-floating mb-3">
                              <input
                                type="text"
                                style="background: #f6f7f9"
                                class="form-control"
                                name="username"
                                id="username"
                                placeholder="Username"
                                formControlName="username"
                                required
                              />
                              <label for="email" class="form-label" style="color: #a6aebc"
                                >ຊື່ຜູ້ໃຊ້</label
                              >
                            </div>
                          </div>
                          <div class="col-12 mt-0">
                            <div class="form-floating mb-3">
                              <input
                                type="password"
                                style="background: #f6f7f9"
                                class="form-control"
                                name="password"
                                id="password"
                                placeholder="ລະຫັດຜ່ານ"
                                formControlName="password"
                                required
                              />
                              <label for="password" class="form-label" style="color: #a6aebc"
                                >ລະຫັດຜ່ານ</label
                              >
                            </div>
                          </div>
                        </div>
                        <div class="row mt-4 pb-3">
                          <!-- Login Error Alert with New Design -->
                          <div *ngIf="showLoginError" class="alert alert-error mb-3" role="alert" aria-live="assertive">
                            <div class="alert-icon">
                              <mat-icon>error</mat-icon>
                            </div>
                            <div class="alert-content">
                              <div class="alert-message">
                                {{ loginError }}
                              </div>
                            </div>
                          </div>

                          <div class="d-grid" style="position: relative">
                            <button
                              class="btn btn-lg text-center"
                              type="submit"
                              style="
                                background-color: #9e1c20;
                                color: #fff;
                                font-family: 'boonhome bold';
                                font-size: 14pt;
                              "
                              (click)="login()"
                            >
                              ເຂົ້າສູ່ລະບົບ
                            </button>
                          </div>

                          <!-- <div class="text-center text-danger mt-2">
                            <small>ເຂົ້າສູ່ລະບົບບໍ່ສຳເລັດ 1/3 ຄັ້ງ</small>
                          </div> -->
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ab-left-login">
    <img src="assets/images/login-page-removebg-preview.png" />
  </div>
  <div class="ab-left-login-logo">
    <img src="assets/images/logo-new-05-2025.png" />
    <div class="text" style="display: none">
      <h1 class="name">ອາໂນມາ ລັດທິດາ</h1>
      <h1>ພິທີກອນ ແລະ ຜູ້ປະກາດຂ່າວ</h1>
    </div>
  </div>
  <div class="right-text-logo">
    <img src="assets/images/20250519_1624_image_text-removebg-preview.png" style="width: 100%" />
  </div>
</section>
